import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { I18N } from '../../../../../constants';
import { formatDateTime } from '../../../../../shared/utils/date';

const idFormatter = (cell, row, formatExtraData, rowIdx) => rowIdx;
const typeFormatter = cell => I18N.TRANSPORT_METHODS[cell] || I18N.RECOVERY_ACTIONS[cell];

const ConfirmationModal = ({ journeyConfirmationData, onConfirm, onClose, showModal, isDisabled, isDismissDisabled }) => (
    <Modal show={showModal} backdrop="static" onHide={onClose} bsSize="lg">
        <Modal.Header>
            <Modal.Title>Are you sure you want to create this journey?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <BootstrapTable data={journeyConfirmationData.recoveryActions}>
                <TableHeaderColumn
                    dataField="recoveryActionType"
                    isKey
                    hidden
                    dataFormat={idFormatter}
                >
                    Key
                </TableHeaderColumn>
                <TableHeaderColumn dataField="recoveryActionType" dataFormat={typeFormatter}>
                    Type
                </TableHeaderColumn>
                <TableHeaderColumn dataField="from">From</TableHeaderColumn>
                <TableHeaderColumn dataField="to">To</TableHeaderColumn>
                <TableHeaderColumn dataField="run">Run</TableHeaderColumn>
                <TableHeaderColumn dataField="tapDate" dataFormat={formatDateTime}>
                    Tap Date
                </TableHeaderColumn>
                <TableHeaderColumn dataField="specialArrivalDate" dataFormat={formatDateTime}>
                    Special Arrival Date
                </TableHeaderColumn>
            </BootstrapTable>
        </Modal.Body>
        <Modal.Footer>
            <Button
                className="pull-right"
                style={{ marginRight: 20 }}
                bsStyle="success"
                onClick={onConfirm}
                disabled={isDisabled}
            >
                Create
            </Button>
            <Button
                className="pull-right"
                style={{ marginRight: 20 }}
                bsStyle="default"
                onClick={onClose}
                disabled={isDismissDisabled}
            >
                Dismiss
            </Button>
        </Modal.Footer>
    </Modal>
);

ConfirmationModal.propTypes = {
    journeyConfirmationData: PropTypes.object,
    onConfirm: PropTypes.func,
    onClose: PropTypes.func,
    showModal: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isDismissDisabled: PropTypes.bool,
};
ConfirmationModal.defaultProps = {
    journeyConfirmationData: {
        recoveryActions: [],
    },
};

export default ConfirmationModal;
